<template>
  <div class="devsignup container-fluid">
    <!-- <div class="row"> -->
    <div class="">
      <router-link to="/">
        <img
          class="navbar-brand logo-size my-5"
          src="/images/logo.png"
          alt="TalentAlt"
        />
      </router-link>
      <router-view></router-view>
    </div>
    <!-- <div class="col-lg-4 bg-dark h-1000 h-ctrl">
                <h2 class="text-white align-center">Sponsors here</h2>
            </div> -->

    <!-- </div> -->
  </div>
</template>
<script>
export default {
  name: 'devsignup',
};
</script>
<style scoped>
.h-ctrl {
  height: 100vh;
}
.logo-size {
  height: 40px;
  /* width: 135px; */
}
</style>
